module.exports = __webpack_public_path__ + "static/media/PM84.f829e495.png";